export default __webpack_public_path__ + "static/media/your_wish_command.d1aa6a41.png";